let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const goLogin = () => {
  if (navigate) {
    navigate("/login", { replace: true });
  }
};
